import { merge } from 'lodash';

import initAuthentication from './_authentication';
import initConstants from './_constants';
import initLayout from './_layout';
import initNormalisationVectors from './_normalisation-vectors';
import initPersonalityTraits from './_personality-traits';
import initReportBlocks from './_report-blocks';
import initReports from './_reports';
import initReportTypes from './_report-types';
import initSubmissions from './_submissions';
import initUsers from './_users';

export default function (app) {
  const subModules = [
    initAuthentication(app),
    initConstants(app),
    initLayout(app),
    initNormalisationVectors(app),
    initPersonalityTraits(app),
    initReportBlocks(app),
    initReports(app),
    initReportTypes(app),
    initSubmissions(app),
    initUsers(app),
  ];

  const getDefaultState = () => ({
    pendingActions: [],
    error: {},

    ...merge(...subModules.map(({ state, }) => state)),
  });

  const state = getDefaultState();

  const getters = {
    isLoading: state => state.pendingActions.length > 0,

    ...merge(...subModules.map(({ getters, }) => getters)),
  };

  const actions = {
    addPendingAction({ commit, }) {
      const id = Math.random();
      commit('addPendingAction', id);
      return id;
    },

    ...merge(...subModules.map(({ actions, }) => actions)),
  };

  const mutations = {
    resetState: state => Object.assign(state, getDefaultState()),
    setError: (state, error) => state.error = error,

    addPendingAction: (state, id) => state.pendingActions.push(id),
    removePendingAction: (state, id) => state.pendingActions = state.pendingActions.filter(e => e !== id),

    setLoading: (state, loading) => state.loading = loading,

    ...merge(...subModules.map(({ mutations, }) => mutations)),
  };

  return {
    namespaced: true,
    state,
    getters,
    actions,
    mutations,
  };
}
